# ------------------------------------*|
#     #Page service
# ------------------------------------*|


modulePage = angular.module 'api.page', []

modulePage.factory 'Page', ["$timeout", "ns", "$injector", "$state", "Restangular", "$http", "$templateCache", "$rootScope", "Template", ($timeout, ns, $injector, $state, Restangular, $http, $templateCache, $rootScope, Template) ->

  page =
    create: (page) ->
      Restangular.all("sites").one($state.params.siteId).all("pages").post page
    update: (page) ->
      if Editor.mode is "email.page.editor"
        id = $state.params.emailId
      else if Editor.mode is "form.page.editor"
        id = $state.params.formId
      else if Editor.mode is "lesson.page.editor"
        id = $state.params.lessonId
      else
        id = $state.params.siteId
      Restangular.all("sites").one(id).all("pages").one(page.id).customPUT page
    delete: (page) ->
      Restangular.all("sites").one($state.params.siteId).all("pages").one(page.id).customDELETE()
    getAll: ->
      Restangular.all("sites").one($state.params.siteId).all("pages").getList()
    sort: (pages) ->
      pagesIds = []
      _.each pages, (page) ->
        pagesIds.push page.id
      Restangular.all("sites").one($state.params.siteId).all("pages").all("sort").post pages: pagesIds
    clone: (pageId) ->
      Restangular.all("sites").one($state.params.siteId).all("pages").one(pageId).all("clone").post()
    remove_background: (pageId) ->
      if Editor.mode is "email.page.editor"
        id = $state.params.emailId
      else if Editor.mode is "form.page.editor"
        id = $state.params.formId
      else if Editor.mode is "lesson.page.editor"
        id = $state.params.lessonId
      else
        id = $state.params.siteId
      Restangular.all("sites").one(id).all("pages").one(pageId).all("remove_background_image").post()
    remove_networking_image: (pageId) ->
      Restangular.all("sites").one($state.params.siteId).all("pages").one(pageId).all("remove_networking_image").post()
  page
]



// WEBPACK FOOTER //
// ./src/app/editor/api/page.coffee